module.exports = __webpack_public_path__ + "img/newsdetails10.61aa91e5.png";